// extracted by mini-css-extract-plugin
module.exports = {"crossBtn":"ModalCloseButton_crossBtn__3bPLr","crossIcon":"ModalCloseButton_crossIcon__3ttqg"};